import { IPrecedingStage, StageDetails } from "../../../types/tournament";
import { Button, Card, Checkbox, Segmented } from "../../../ui";

interface Props {
  stage?: StageDetails;
  stageDependent: boolean;
  setStageDependent: (v: boolean) => void;
  selectedStages: IPrecedingStage[];
  setSelectedStages: React.Dispatch<React.SetStateAction<IPrecedingStage[]>>;
  selectedTeams: string[];
  setSelectedTeams: React.Dispatch<React.SetStateAction<string[]>>;
}

const DEPENDS_QUESTION = "Does this stage depend on other stages for qualification?";

const DependentStagesStep = ({
  stage, stageDependent, setStageDependent, selectedStages, setSelectedStages, selectedTeams, setSelectedTeams,
}: Props) => (
  <div className="cs-step dependent-stages-container">
    <Card title={DEPENDS_QUESTION}>
      <Segmented
        ariaLabel={DEPENDS_QUESTION}
        options={[
          { value: "yes", label: "Yes", disabled: stage?.precedingStages.length === 0 },
          { value: "no", label: "No" },
        ]}
        value={stageDependent ? "yes" : "no"}
        onChange={(answer) => {
          if (answer === "yes") {
            if (stage?.precedingStages.length === 0) return;
            setStageDependent(true);
            if (!stageDependent) setSelectedStages([]);
          } else {
            setStageDependent(false);
            if (stageDependent) setSelectedTeams([]);
          }
        }}
      />
    </Card>
    <Card
      title={
        stageDependent
          ? "Select the stages that determine qualification to this stage"
          : "Select the teams participating in this stage"
      }
      subtitle={
        <span className="teams-count">
          {stageDependent ? selectedStages.length : selectedTeams.length} selected {stageDependent ? "stages" : "teams"}
        </span>
      }
      actions={
        <>
          <Button
            size="sm"
            variant="tint"
            onClick={() =>
              stageDependent
                ? setSelectedStages(stage?.precedingStages.map((x) => ({ ...x, value: 1, fromPosition: 1, toPosition: 1 })) || [])
                : setSelectedTeams(stage?.teams.map((x) => x.id) || [])
            }
          >
            Select all
          </Button>
          <Button size="sm" variant="ghost" onClick={() => (stageDependent ? setSelectedStages([]) : setSelectedTeams([]))}>
            Unselect all
          </Button>
        </>
      }
    >
      {stageDependent ? (
        <div className="cs-pick-grid preceding-stages">
          {stage?.precedingStages.map((item, idx) => {
            const checked = selectedStages.findIndex((x) => x.id === item.id) !== -1;
            return (
              <Checkbox
                key={idx}
                className={`cs-pick${checked ? " is-on" : ""}`}
                checked={checked}
                label={`Stage ${item.stageOrder} - ${item.stageName}`}
                onChange={() =>
                  setSelectedStages((prev) => {
                    let updatedStages = [...prev];
                    const i = updatedStages.findIndex((x) => x.id == item.id);
                    if (i === -1) updatedStages.push({ ...item, value: 1, fromPosition: 1, toPosition: 1 });
                    else updatedStages = updatedStages.filter((x) => x.id !== item.id);
                    return updatedStages;
                  })
                }
              />
            );
          })}
        </div>
      ) : (
        <div className="cs-pick-grid teams-list">
          {stage?.teams.map((item, idx) => {
            const checked = selectedTeams.findIndex((x) => x === item.id) !== -1;
            return (
              <Checkbox
                key={idx}
                className={`cs-pick${checked ? " is-on" : ""}`}
                checked={checked}
                label={item.teamName}
                onChange={() =>
                  setSelectedTeams((prev) => {
                    let updatedTeams = [...prev];
                    const i = updatedTeams.findIndex((x) => x == item.id);
                    if (i === -1) updatedTeams.push(item.id);
                    else updatedTeams = updatedTeams.filter((x) => x !== item.id);
                    return updatedTeams;
                  })
                }
              />
            );
          })}
        </div>
      )}
    </Card>
  </div>
);

export default DependentStagesStep;
